import { TSegmentThumbnail } from '../types';

export function getOffsetMs(
  datetime: string | null | undefined,
  referenceDatetime: string | null | undefined
): number | null {
  if (!datetime || !referenceDatetime) return null;
  const t = new Date(datetime).getTime();
  const ref = new Date(referenceDatetime).getTime();
  if (isNaN(t) || isNaN(ref)) return null;
  return t - ref;
}

export function resolveThumbnail(
  startOffsetMs: number | null,
  thumbnails: TSegmentThumbnail[]
): TSegmentThumbnail | null {
  if (startOffsetMs === null || thumbnails.length === 0) return null;

  const sorted = [...thumbnails].sort((a, b) => a.start_time_ms - b.start_time_ms);

  // Round up: pick the first thumbnail whose start is at or after startOffsetMs,
  // so the presence is more likely to already be visible in the captured frame.
  const ceil = sorted.find(t => t.start_time_ms >= startOffsetMs);
  if (ceil) return ceil;

  // Fallback: startOffsetMs is past all thumbnails, return the last one
  return sorted[sorted.length - 1] ?? null;
}
